import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  imageWrapper: {
    marginBottom: SPACES.s,
    marginTop: SPACES.s,
  },
  image: {
    '&&': {
      width: 65,
      height: 65,
      objectFit: 'cover',
    },
  },
}))

export { useStyles }
